import { TextField } from '@mui/material';
import type { useFormik } from 'formik';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogForm } from '~/components/dialogs/lib';
import { NumberPairField } from '~/components/forms/number-pair';

export interface ZoneFormValues {
  height: number;
  left: number;
  name: string;
  top: number;
  width: number;
}

export interface ZoneFormProps<T extends ZoneFormValues>
  extends Omit<ComponentProps<'form'>, 'onSubmit'> {
  formik: ReturnType<typeof useFormik<T>>;
}

export const ZoneForm = <T extends ZoneFormValues>({ formik, ...props }: ZoneFormProps<T>) => {
  const { t } = useTranslation();
  return (
    <DialogForm onSubmit={formik.handleSubmit} {...props}>
      <label>
        <span className={`label required`}>{t('common.labels.name')}</span>
        <TextField
          error={formik.touched.name && !!formik.errors.name}
          fullWidth
          helperText={(formik.touched.name && formik.errors.name) || ' '}
          name="name"
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          value={formik.values.name}
          focused
          autoFocus
        />
      </label>
      <NumberPairField
        fields={[
          { label: t('common.labels.width'), name: 'width', sx: { mr: 1 } },
          { label: t('common.labels.height'), name: 'height', sx: { ml: 1 } },
        ]}
        formik={formik}
        label={t('common.labels.size')}
        required
        separator={<span>x</span>}
      />
      <NumberPairField
        fields={[
          { label: t('pages.layouts.zone_form.labels.left_x'), name: 'left', sx: { mt: 1, mr: 1 } },
          { label: t('pages.layouts.zone_form.labels.top_y'), name: 'top', sx: { mt: 1, ml: 1 } },
        ]}
        formik={formik}
        label={t('pages.layouts.zone_form.labels.position')}
        required
      />
    </DialogForm>
  );
};
